import { Injectable } from '@angular/core';
import { Observable, from, map, mergeMap, of, switchMap } from 'rxjs';
import { LogoImageContractService } from '../interfaces/logo-image-contract.service';
import { ElectronService } from '../../electron.service';
import { FILE_SYSTEM, IPC_CHANNEL } from '../../_offline/electron.constants';
import { UtilsService } from '../_utils.service';
import { NetworkStatusService } from '../network-status.service';

@Injectable({
  providedIn: 'root'
})
export class LogoImageOfflineService implements LogoImageContractService {

  private LOGO_FILE_NAME = "LOGO.BMP";
  private LOGO_ABSOLUTE_PATH: string;

  constructor(private _electronService: ElectronService, private utilService: UtilsService, private networkStatusService: NetworkStatusService) {
    // this will throw in a web application, we only init the value in desktop mode
    if (this.networkStatusService.isDesktop()) {
      this.getUserDataPath()
      .subscribe(path => {
        this.LOGO_ABSOLUTE_PATH = `${path}/${FILE_SYSTEM.PATH.LOGO}/${this.LOGO_FILE_NAME}`;
      });
    }
  }

  getLogoImage(): Observable<string |  null> {
    return this.sendIPCCommand(IPC_CHANNEL.FILE.IS_FILE_EXISTS, this.LOGO_ABSOLUTE_PATH)
      .pipe(
        map(logo => logo ?`${this.LOGO_ABSOLUTE_PATH}?t=${new Date().getTime()}`: null)
        );
  }

  uploadLogoImage(file: File): Observable<unknown> {
    return from(this.utilService.fileToBase64(file))
      .pipe(switchMap((base64) => this.sendIPCCommand(IPC_CHANNEL.FILE.PUT_ONE, this.LOGO_ABSOLUTE_PATH, base64, file.type)));
  }

  deleteLogo(): Observable<unknown> {
    return this.sendIPCCommand(IPC_CHANNEL.FILE.DELETE_FOLDER,this.LOGO_ABSOLUTE_PATH);
  }

  private getUserDataPath() {
    return this.sendIPCCommand(IPC_CHANNEL.FILE.GET_APP_FOLDER_PATH);
  }

  private sendIPCCommand(channel: string, ...args: any[]) {
    return of(this._electronService.sendSyncCommand(channel, ...args));
  }
}
